
export enum AgentType {
  PATIENT_WAL_IN = 'PATIENT_WAL_IN',
  PATIENT_TRAUMA = 'PATIENT_TRAUMA', 
  PATIENT_STROKE = 'PATIENT_STROKE',
  PATIENT_EMS = 'PATIENT_EMS', 
  PATIENT_INFECTIOUS = 'PATIENT_INFECTIOUS',
  COMPANION = 'COMPANION',
  DOCTOR = 'DOCTOR',
  NURSE = 'NURSE',
  NURSE_ASSISTANT = 'NURSE_ASSISTANT', 
  SPECIALIST_TEAM = 'SPECIALIST_TEAM'
}

export enum AgentState {
  IDLE = 'IDLE',
  MOVING = 'MOVING',
  WAITING = 'WAITING', 
  WAITING_FOR_CARE = 'WAITING_FOR_CARE', 
  PROCESSING = 'PROCESSING', 
  EXITING = 'EXITING'
}

export interface Agent {
  id: string;
  type: AgentType;
  state: AgentState;
  x: number;
  y: number;
  targetNodeId: string | null;
  currentNodeId: string | null;
  path: string[]; 
  progress: number; 
  health: number; 
  totalWaitTime: number; 
  totalDistancePixels: number; 
  totalActiveTime: number;
  tickCreated: number;
  tickOnArrival: number;
  tickFirstSeen: number | null; 
  tickLabOrdered: number | null;
  tickLabResult: number | null;
  assignedStaffId?: string | null; 
  assignedPatientId?: string | null; 
  companionOf?: string | null; 
  taskType?: 'TREATMENT' | 'LAB_RUN' | 'PATIENT_TRANSPORT' | null; 
  carryingSpecimen?: boolean;
  isTransportingPatient?: boolean;
  infected: boolean;
  infectionRisk: number; 
  acuity: number; 
  patience: number; 
  maxPatience: number;
  needsLab: boolean;
  labDone: boolean;
  needsImaging: boolean;
  imagingDone: boolean;
  needsPharmacy: boolean;
  awaitingResults: boolean; 
}

export interface SimulationStats {
  treatedPatients: number;
  activePatients: number;
  avgWaitTime: number; 
  avgDistanceTraveled: number; 
  avgDistanceByRole: {
      patients: number;
      doctors: number;
      nurses: number;
      assistants: number;
  };
  staffUtilization: {
      doctors: number; 
      nurses: number;
      assistants: number;
  };
  criticalEvents: number; 
  infections: number; 
  lwbs: number; 
  avgDoorToDoc: number; 
  avgLengthOfStay: number; 
  avgLabTurnaround: number; 
  bedOccupancyRate: number; 
}

export interface SimulationConfig {
    // Klinikiniai laikai
    labProcessingTime: number; 
    admissionRate: number; 
    dischargeProcessTime: number; 
    imagingRate: number; 
    // Agentų elgsena
    basePatientSpeed: number;
    baseStaffSpeed: number;
    patienceDepletionRate: number;
    // Infekcijos sklaida
    infectionProbability: number;
    infectionRadius: number;
    nodeContaminationRate: number;
    // Logistikos ir srauto logika
    staffPrioritization: 'ACUITY' | 'FIFO';
    avoidContamination: boolean;
    allowHallwayWaiting: boolean;
    congestionAwareness: number;
    // Klinikinis eiliškumas (Nauja)
    skipTriageForCritical: boolean;
    strictIsolationProtocol: boolean;
    diagnosticsFirst: boolean;
    fastTrackTrauma: boolean;
}
